import { useEffect, useState } from 'react';
import { useProfileQuery } from 'src/modules/myProfile/src/profileQueries';
import WelcomeLine from '../../../components/WelcomeLine';
import { useDict } from '../../../contexts/LanguageContext';
import { useStatementDispatch } from '../../../contexts/StatementContext';
import { useStatusModalContext } from '../../../contexts/StatusModalContext';
import { getPerformanceRecords } from '../src/performanceApis';
import ChartPerformance from './ChartPerformance';
import FilteringChartPerformance from './FilteringChartPerformance';
import ListPerformance from './ListPerformance';

const Performance = () => {
    const dict = useDict();

    const statementDispatch = useStatementDispatch();
    const { openStatusModal } = useStatusModalContext();

    const [eWalletBalanceData, setEWalletBalanceData] = useState(null);
    const [performanceData, setPerformanceData] = useState([]);
    const [isFetching, setIsFetching] = useState(false);

    const { data: profileData } = useProfileQuery();

    useEffect(() => {
        setIsFetching(true);
        window.scrollTo(0, 0);
        getPerformanceRecords(
            handleGetPerformanceRecords,
            handleGetPerformanceRecordsError
        );
        setIsFetching(false);
    }, []);

    const handleGetPerformanceRecords = (response) => {
        const { data: responseData } = response.data;
        const currentMonthRecord = {
            [new Date().toISOString().slice(0, 7)]:
                responseData?.['current-record'],
        };

        // Do not display the initial months with 0 profit return and service fee
        let foundNonZero = false;
        const filteredPerformanceRecord = Object.entries(responseData['performance-record']).reduce((acc, [key, value]) => {
            if (!foundNonZero) {
                if (value.profit_return !== "0.00" || value.service_fee !== "0.00") {
                    foundNonZero = true;
                }
                if (foundNonZero) {
                    acc[key] = value;
                }
            } else {
                acc[key] = value;
            }
            return acc;
        }, {});

        responseData['current-record'] = currentMonthRecord;
        responseData['performance-record'] = filteredPerformanceRecord;
        setPerformanceData(responseData);
    };

    const handleGetPerformanceRecordsError = (error) => {
        openStatusModal({
            refresh: false,
            title: dict.performance,
            message: dict.generalErrorMessage,
            isSuccess: false,
            isError: true,
        });
    };

    return (
        <div className="page-wrapper">
            <div className="dashboard-section container">
                <WelcomeLine
                    name={profileData?.first_name || 'N/A'}
                />
                <div className="performance__summary-container">
                    <ChartPerformance
                        doStatement={() =>
                            statementDispatch({
                                type: 'openStatementOptionModal',
                            })
                        }
                        graphData={
                            performanceData?.['graph-record'] ?? {}
                        }
                        annualRate={performanceData?.overall?.net_return_rate ?? 0}
                        accumulatedReturn={
                            performanceData?.overall?.net_return ?? '0'
                        }
                        isLoading={isFetching}
                    />
                    <FilteringChartPerformance
                        annualRate={performanceData?.overall?.net_return_rate ?? 0}
                        accumulatedReturn={
                            performanceData?.overall?.net_return ?? '0'
                        }
                        isLoading={isFetching}
                    />
                </div>
            </div>
            <div className="performance__listing container">
                <ListPerformance
                    totalIncome={performanceData?.['overall'] ?? {}}
                    pastMonthlySummary={performanceData?.['performance-record']}
                    totalExpectedThisMonth={performanceData?.['current-record']}
                    isLoading={isFetching}
                />
            </div>
        </div>
    );
};

export default Performance;
